<p>base-image-texture-set works!</p>
